const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on("unmount", () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

// UI COMPONENTS ==============================================================
import Slider from "./components/ui/Slider";
import Collage from "./components/ui/Collage";
import MediaPlayer from "./components/media/MediaPlayer";
// NAV COMPONENTS ==============================================================

export const AppComponents = {
  // NAV COMPONENTS ==============================================================

  // Content Components ------------------------------------------------------------

  // PRODUCT Components ---------------------------------------------------------

  // MEDIA Components ------------------------------------------------------------
  Collage,
  Slider,
  MediaPlayer,

  // UI Components ------------------------------------------------------------
};
